import React, { useContext, useEffect, useState } from 'react';
import { GeoLocationContext } from 'components/explore/GeoLocationProvider';
import useIsochroneSearch from 'hooks/useIsochroneSearch';
import { FullscreenSearchApp } from 'react_components/search/fullscreen/search_app';
import useFeatures from 'hooks/useFeatures';
import { PageStrings } from '@alltrails/shared/utils/constants/pageStringHelpers';

type Props = {
  belongsToCurrentUser: boolean;
  isMobileWidth: boolean;
  latestListAction: any;
  listId: any;
  listItems: any;
  listMethods: any;
  lists: any;
  page: string;
  updatePage: any;
  userListItems: any;
};

/**
 * NewFullscreenSearchApp wraps the legacy React class component FullscreenSearchApp
 * with a new functional component that can access hooks.
 *
 * Over time functionality from FullscreenSearchApp should be refactored. For
 * now this can (hopefully) be a shim to help provide modern functionality.
 *
 * @param {props} Props
 * @returns JSX.Element
 */
export default function NewFullscreenSearchApp({
  belongsToCurrentUser,
  isMobileWidth,
  latestListAction,
  listId,
  listItems,
  listMethods,
  lists,
  page,
  updatePage,
  userListItems,
  ...rest
}: Props) {
  const [distanceAwayValue, setDistanceAwayValue] = useState<number>();
  const { geoLocation, getGeoLocation } = useContext(GeoLocationContext);
  const {
    isLoading: isLoadingIsochrone,
    isochroneData,
    insidePolygon,
    isochroneBoundingBox
  } = useIsochroneSearch({ distanceAwayValue, geoLocation });

  useEffect(() => {
    if (distanceAwayValue && distanceAwayValue !== -1) {
      // TODO DISCO-874 re-use functionality in SliderGroup to present a modal to
      // users about geo location if needed.
      getGeoLocation();
    }
  }, [distanceAwayValue, getGeoLocation]);

  const features = useFeatures();
  const useNewMaps = features.includes('new_maps') && page === PageStrings.EXPLORE_ALL_PAGE;

  return (
    <FullscreenSearchApp
      {...rest}
      geoLocation={geoLocation}
      insidePolygon={insidePolygon}
      isLoadingIsochrone={isLoadingIsochrone}
      isMobileWidth={isMobileWidth}
      isochroneBoundingBox={isochroneBoundingBox}
      isochroneData={isochroneData}
      latestListAction={latestListAction}
      lists={lists}
      listItems={listItems}
      page={page}
      useNewMaps={useNewMaps}
      userListItems={userListItems}
      listMethods={listMethods}
      listId={listId}
      belongsToCurrentUser={belongsToCurrentUser}
      updatePage={updatePage}
      onUpdateDistanceAway={(value: number) => {
        setDistanceAwayValue(value);
      }}
    />
  );
}
